/**
 * @voltxampere/ui — 10W power resistor variant (Sprint 38-4)
 *
 * Reference: yaygın 10 W aluminum-clad chassis-mount direnç (motor
 * driver dummy load, kondansatör boşaltma, current sense).
 *
 *   resistance  = 100 Ω      (kullanıcı override)
 *   powerRating = 10 W
 *
 * Sprint 38-5 R_thermal table'a `resistor / 10w-alclad` entry
 * eklenir (R_th = 7 °C/W, T_max = 250 °C — alüminyum gövde aktif
 * olarak ısı dağıtır).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const resistor10w = {
    id: "resistor-10w",
    nameTr: "Direnç 10W (aluminum-clad)",
    nameEn: "Resistor 10W (aluminum-clad)",
    shortcut: "R",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "R",
    defaultValue: "100Ω 10W",
    schemaType: "resistor",
    defaultParams: { resistance: 100, powerRating: 10 },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=resistor-10w.js.map